import firebase from 'firebase/app'
import "firebase/auth";
import 'firebase/firestore'




const firebaseConfig =
{
  apiKey: "AIzaSyCpbNCtaM6FNE7QhI9pezk5LsoTBM6RuAQ",
  authDomain: "glor-partner.firebaseapp.com",
  databaseURL: "https://glor-partner.firebaseio.com",
  projectId: "glor-partner",
  storageBucket: "glor-partner.appspot.com",
  messagingSenderId: "308937762072",
  appId: "1:308937762072:web:5e95a89617144bdbd9ea6d",
  measurementId: "G-XTSDXB59BF"
}


/* base setyup for firebase and auth */
const fb = firebase.initializeApp(firebaseConfig)

const db = fb.firestore()

const auth = fb.auth()
auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL)

export { auth, db }
